<template>
  <div class="journal-main">
    <div class="cover-v wow slideInLeft">
      <img alt="" class="cover-img" src="@/assets/img/journal/cover.png" />
      <button class="btn" @click="goSub">去投稿</button>
    </div>
    <div class="journal-main-right wow slideInRight">
      <p class="text-1">
        应用统计与数据科学--Applied Statistics and Data Science
      </p>
      <p class="text-2">
        《应用统计与数据科学》期刊的宗旨是紧跟统计学、数学、计算机科学及数据科学领域的发展趋势，精准快速地反映这些学科在经济学、金融学、医学、教育学、心理学、社会学.管理学、人工智能、大数据管理等交叉学科中的新进展、新技术、新成果。期刊旨在为统计学、数据科学以及相关交叉学科领域搭建学术交流平台，促进新技术在实际应用中的推广与创新发展，推动统计学、数学、计算机科学等领域的跨学科融合与发展。
      </p>
      <div class="text-3 flex">
        <p>ISSN Print:3066-8433</p>
        <p style="margin-left: 40px">ISSN Online:3066-8441</p>
      </div>
      <div class="flex">
        <p>
          <span class="label">编辑邮箱:</span>
          <span class="http"> editor_asds@gztjssws.com</span>
        </p>
        <!--        <p style="margin-left: 40px">-->
        <!--          <span class="label">微信: </span>-->
        <!--          <span class="value">ASDS-Editor</span>-->
        <!--        </p>-->
        <p style="margin-left: 40px">
          <span class="label">手机号: </span>
          <span class="value">15992148024（微信号同手机号）</span>
        </p>
      </div>
      <div class="flex">
        <p>
          <span class="label">编辑企业微信: </span>
          <a
            class="http"
            href="https://work.weixin.qq.com/ca/cawcde5e5b73c9fadb"
          >
            https://work.weixin.qq.com/ca/cawcde5e5b73c9fadb</a
          >
        </p>
      </div>
      <div class="flex">
        <p>
          <span class="label">Website: </span>
          <a class="http" href="https://www.artdesignp.com/journal/ASDS">
            https://www.artdesignp.com/journal/ASDS</a
          >
        </p>
      </div>
      <div class="flex">
        <p>
          <span class="label">主办单位: </span>
          <span class="value">ART AND DESIGN PRESS INC(United States)</span>
        </p>
        <p style="margin-left: 40px">
          <span class="label">承办单位: </span>
          <span class="value"
            >广州统计师事务所(Guangzhou Statistician Firm)</span
          >
        </p>
      </div>
      <p>
        <span class="label">指导单位:</span>
        <span class="value"
          >广东省现场统计学会(Guangdong Association of Applied
          Statistics)、广州市统计学会(Guangzhou Association of Statistics)</span
        >
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "JournalCover",
  data() {
    return {};
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    goSub() {
      this.$router.push({ name: "journalSubmit" });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
  align-items: center;
}

.journal-main {
  margin-top: 30px;
  display: flex;

  .cover-v {
    width: 190px;
    margin-right: 30px;

    .cover-img {
      width: 190px;
      height: 257px;
    }

    .btn {
      width: 190px;
      height: 42px;
      margin-top: 10px;
      background: #ed9700;
      border-radius: 8px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      line-height: 42px;
      border: none;
      cursor: pointer;

      &:active {
        opacity: 0.7;
      }
    }
  }

  .journal-main-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .text-1 {
      font-weight: bold;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
    }

    .text-2 {
      font-size: 16px;
      color: #666666;
      line-height: 29px;
    }

    .text-3 {
      font-size: 16px;
      color: #333333;
      line-height: 31px;
    }

    .label {
      font-size: 14px;
      color: #333333;
    }

    .http {
      font-size: 14px;
      color: #3c58d3;
    }

    .value {
      font-size: 14px;
      color: #666666;
    }
  }
}
</style>
